import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import s from './index.module.css';

const Button = ({
  className, // string w button className selector
  view, // optional string. if set value 'button' than apply default styles for font, padding and borders
  background, // string w enum for setting background btn from 3 themes - white, blue, red
  type, // string w button type - submit or button
  onClick, // func w callback
  onMouseDown,
  children,
  id,
  disabled, // bool. If set true, than onClick callback won't be triggered
  disabledClassName, // string w classname that aplies on disabled = true
}) => {
  const handleClick = (e) => {
    if (onClick && !disabled) {
      onClick(e);
    }
  };

  return (
    <button
      id={id}
      className={cx(s.button, className, {
        [s.view_button]: view === 'button',
        [s.background_white]: background === 'white',
        [s.background_blue]: background === 'blue',
        [s.background_red]: background === 'red',
        [disabledClassName]: disabled && disabledClassName,
      })}
      type={type || 'button'}
      onClick={handleClick}
      onMouseDown={onMouseDown}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  id: PropTypes.string,
  view: PropTypes.oneOf(['button']),
  background: PropTypes.oneOf(['white', 'blue', 'red']),
  type: PropTypes.oneOf(['button', 'submit']),
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
};

export default Button;
